<div class="container_tab_nav" *ngIf="elaborationId">
  <ul class="nav nav-tabs two">
    <li [style.width.%]="50" class="active">
      <a aria-expanded="true" data-toggle="tab" href="#tab-document-content">Testo estratto</a>
    </li>
    <li [style.width.%]="50" class="" (click)="loadElaboration()">
      <a aria-expanded="false" data-toggle="tab" href="#tab-document-viewer">Documento originale</a>
    </li>
  </ul>
  <div class="tab-content">
    <div class="tab-pane fade active in" id="tab-document-content" *ngIf="pageText$ | async as pageText">
      <p [innerHTML]="pageText | replaceLineBreaks"></p>
      <!-- <p [innerHTML]="pageText"></p> -->
      <ng-container *ngIf="pagesNumber$ | async as pagesNumber">
        <app-pagination-document [nPages]="pagesNumber" (changePage)="changePage($event)">
        </app-pagination-document>
      </ng-container>
    </div>
    <div class="tab-pane fade" id="tab-document-viewer">
      <div *ngIf="src">
        <iframe [src]="src" type="application/pdf" width="100%" height="100%" style="overflow: auto;">
        </iframe>
      </div>
    </div>
  </div>
</div>

